import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { redirectByRole } from '../utils/auth';
import { useAuth } from '../contexts/AuthContext';

const AuthLayout = () => {
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (isAuthenticated() && user) {
      const userRole = user.role || user.roles?.[0]?.name;
      redirectByRole(userRole);
    }
  }, [isAuthenticated, user]);
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h1 className="text-center text-3xl font-extrabold text-brand-navy">
          Datavisual <span className="text-brand-navy">3PL</span><span className="text-brand-gold">+</span>
        </h1>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout; 
